import { navigateTo, useRoute } from '#imports'
import { ref, watch } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { isEqual } from '@backmarket/utils/object/isEqual'

import { TRACKING_PAGE_TYPE_BY_ROUTE_NAME } from '~/constants/trackingPageType'

import { TRACKING_ZONE } from '../../../constants'

export function useRatingFilters() {
  const route = useRoute()
  const { trackClick } = useTracking()

  const range = ref<[number, number]>([1, 5])
  const previousRange = ref<[number, number]>(range.value)

  function initializeRangeFromQuery() {
    const { global_rate__gte: minRange, global_rate__lte: maxRange } =
      route.query

    const min = minRange ? Number(minRange) : 1
    const max = maxRange ? Number(maxRange) : 5

    const validMin = Math.max(1, Math.min(5, min))
    const validMax = Math.max(1, Math.min(5, max))

    if (validMin <= validMax) {
      range.value = [validMin, validMax]
    } else {
      range.value = [1, 5]
    }
    previousRange.value = range.value
  }

  async function navigateAndTrackRange(newRange: [number, number]) {
    if (isEqual(newRange, previousRange.value)) return
    const [min, max] = newRange

    trackClick({
      pageType: TRACKING_PAGE_TYPE_BY_ROUTE_NAME[route.name?.toString() || ''],
      zone: TRACKING_ZONE,
      name: `review_star_filter_between_${min}_and_${max}`,
    })

    await navigateTo({
      ...route,
      hash: route.hash,
      query: {
        ...route.query,
        global_rate__gte: min.toString(),
        global_rate__lte: max.toString(),
        cursor: undefined,
      },
    })
    previousRange.value = newRange
  }

  watch(
    () => route.query,
    () => initializeRangeFromQuery(),
    { immediate: true },
  )

  return {
    range,
    navigateAndTrackRange,
  }
}
